'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var navigationItems = context.getElements('.' + context.className + '_Navigation');

  navigationItems.forEach(function (navigationItem) {
    var navigationTitle = (0, _functional.getElement)('.' + context.className + '_Title', {
      context: navigationItem
    });

    navigationTitle.addEventListener('click', function (e) {
      e.preventDefault();

      navigationItem.classList.toggle('drw-Nav_Item-active');
    });
  });
}